import { render, staticRenderFns } from "./AlertMenu.vue?vue&type=template&id=06c922f3"
import script from "./AlertMenu.vue?vue&type=script&lang=js"
export * from "./AlertMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports